<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<main role="main">
    <h2 id="title-hold">{{ 'onhold.title' | translate }}</h2>
    <section class="infoBox">
        <p id="info-hold">{{ 'onhold.description' | translate }}</p>
    </section>
</main>